export function getDefaultData(name) {
  return {
    name,
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
${name}さんの友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_kanta.gif",
    type: "face",
    movieId: "kanta_normal"
  };
}

export const specialResultData = {
  name: "カンタ",
  text: `カンタさんカンタさんカンタさん

ここです
はやくきて？

東業都中並区水台444-444`,
  imgPath: "pic_ghost.gif",
  type: "face",
  movieId: "baby"
};

export const resultDataList = [
  {
    name: "トミー",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
トミーさんのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_tomy.gif",
    type: "face",
    movieId: "tomy_normal"
  },
  {
    name: "富永知義",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
富永知義さんのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_tomy.gif",
    type: "face",
    movieId: "tomy_normal"
  },
  {
    name: "カンタ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
カンタさんのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_kanta.gif",
    type: "face",
    movieId: "kanta_normal"
  },
  {
    name: "佐藤寛太",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
佐藤寛太さんのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_kanta.gif",
    type: "face",
    movieId: "kanta_normal"
  },
  {
    name: "逢坂良一",
    text: `そんなびっくりすんなや！
ちょっとドッキリ仕掛けただけだって。

この診断をシェアして
まわりの友達も
びっくりさせてみてね〜。`,
    imgPath: "tomy_dorama.png",
    type: "picture",
    movieId: "tomy_dorama"
  },
  {
    name: "工藤裕也",
    text: `はいどうも〜！水溜りボンドのカンタです。
ドッキリに引っかかっちゃいました？

この診断をシェアして
まわりの友達も
びっくりさせてみてくださいね！`,
    imgPath: "kanta_dorama.png",
    type: "picture",
    movieId: "kanta_dorama"
  },
  {
    name: "てつや",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたてつやです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_tetsuya.png",
    type: "picture",
    movieId: "art_tetsuya"
  },
  {
    name: "しばゆー",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたしばゆーです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_sibayu.png",
    type: "picture",
    movieId: "art_sibayu"
  },
  {
    name: "りょう",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたりょうです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_ryo.png",
    type: "picture",
    movieId: "art_ryo"
  },
  {
    name: "としみつ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたとしみつです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_toshimitsu.png",
    type: "picture",
    movieId: "art_toshimitsu"
  },
  {
    name: "ゆめまる",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたゆめまるです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_yumemaru.png",
    type: "picture",
    movieId: "art_yumemaru"
  },
  {
    name: "虫眼鏡",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いた虫眼鏡です。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_mushimegane.png",
    type: "picture",
    movieId: "art_mushimegane"
  },
  {
    name: "ジョージ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたジョージです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_joji.png",
    type: "picture",
    movieId: "art_jyoji"
  },
  {
    name: "ジロー",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたジローです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_jiro.png",
    type: "picture",
    movieId: "art_jiro"
  },
  {
    name: "みの",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたみのです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_mino.png",
    type: "picture",
    movieId: "art_mino"
  },
  {
    name: "そらちぃ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたそらちぃです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_sorati.png",
    type: "picture",
    movieId: "art_sorachi"
  },
  {
    name: "エイジ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたエイジです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_eiji.png",
    type: "picture",
    movieId: "art_eiji"
  },
  {
    name: "ツリメ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたツリメです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_tsurime.png",
    type: "picture",
    movieId: "art_tsumeri"
  },
  {
    name: "リクヲ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたリクヲです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_rikuwo.png",
    type: "picture",
    movieId: "art_rikuwo"
  },
  {
    name: "ぶんけい",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたぶんけいです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_bunkei.png",
    type: "picture",
    movieId: "art_bunkei"
  },
  {
    name: "＠小豆",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いた＠小豆です。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_azuki.png",
    type: "picture",
    movieId: "art_azuki"
  },
  {
    name: "ンダホ",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

ちなみにこのイラストは
僕カンタが描いたンダホです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "art_ndaho.png",
    type: "picture",
    movieId: "art_ndaho"
  },
  {
    name: "山原楓",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_ghost.gif",
    type: "face",
    movieId: "baby"
  },
  {
    name: "篠原郁美",
    text: `びっくりさせてごめんなさい。
ちょっとした、いたずらです。

この診断をシェアして
まわりのお友達も
びっくりさせちゃいましょう。`,
    imgPath: "pic_ghost.gif",
    type: "face",
    movieId: "baby"
  }
];
